<template>
  <v-dialog :value="isOpen" width="828px" height="380px">
    <v-card class="card-container" elevation="0">
      <img :src="require(`@/assets/club-card-dialog-${variant}.svg`)" alt="maria" />
      <div class="pa-5 pl-0 d-flex flex-column">
        <h1 class="mb-5">{{ title }}</h1>
        <p>{{ text }}</p>
        <div class="d-flex align-end justify-end button-container">
          <mf-button text-transform="none" color="marca-0-l10" label="Ok" @click="isOpen = false" />
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ClubCardDialog',
  components: {},
  props: {
    variant: {
      type: String,
      default: 'positive',
      validator: (value) => ['', 'positive', 'negative'].includes(value),
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    title() {
      return this.variant === 'positive' ? 'Cupons do clube contendo ofertas' : 'Cupons fora do clube contendo ofertas'
    },
    text() {
      return this.variant === 'positive'
        ? 'Um alto percentual de cupons de seu clube que incluem produtos em oferta é um indicativo forte de que o seu clube de benefícios está performando bem. Esse resultado positivo é fruto de uma combinação de ofertas atrativas e uma comunicação eficaz com os consumidores. Quanto maior for esse percentual, mais claro fica o sucesso das suas estratégias em engajar e fidelizar os clientes.'
        : 'Poucos cupons não identificados com produtos em oferta elegíveis são um excelente sinal para o seu clube de benefícios. Isso mostra que a maioria dos clientes está aproveitando bem as ofertas que você disponibiliza. Quanto menor for esse número, melhor será o desempenho do seu clube, pois indica que os clientes estão bem informados sobre as vantagens e não estão perdendo a oportunidade de economizar e fidelizar-se.'
    },
    isOpen: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.card-container {
  display: grid;
  grid-template-columns: 380px 1fr;
  gap: 24px;
}

img {
  width: 100%;
  display: block;
  border-radius: 0 !important;
}

h1 {
  font-size: 22px;
  color: $cinza-d10;
  font-weight: 700;
}

p {
  font-size: 16px;
  color: $cinza-0;
  line-height: 24px;
}

.button-container {
  flex: 1;
}
</style>
